import { useInfiniteQuery } from 'react-query';

import { baseApiUrl, fetcher, ServerErrorResponse, infiniteEmptyResults } from 'data_sources/constants';

import type { ManualAcknowledgementSchedule } from 'views/App/Portal/Policy/_types/acknowledgements';
import type { CursorCollectionResponse } from 'types/api_response';

export default function useIssuedManualAcknowledgementSchedules<T extends ManualAcknowledgementSchedule>(
  manualId: string,
  params = {},
  options: object = {},
  onError?: (errors: ServerErrorResponse) => void
) {
  const url = `${baseApiUrl()}/lexipub/acknowledgements/v1/admin/manuals/${manualId}/schedules`;

  return useInfiniteQuery<CursorCollectionResponse<T>, Error>(
    ['issued_manual_acknowledgment_schedules', manualId, params],
    async ({ pageParam, signal }): Promise<CursorCollectionResponse<T>> => {
      const paramString = new URLSearchParams(
        Object.entries({
          ...params,
        })
          // eslint-disable-next-line no-unused-vars
          .filter(([_k, v]) => v != null)
          .reduce((acc, [k, v]) => ({ ...acc, [k]: v }), {})
      ).toString();
      const data: CursorCollectionResponse<T> = await fetcher({
        method: 'get',
        url: pageParam || `${url}?${paramString}`,
        options: { signal },
      });

      return data;
    },
    {
      ...options,
      keepPreviousData: true,
      getNextPageParam: (lastPage) => {
        if (lastPage.lastKey && lastPage.content.length > 0) {
          const paramString = new URLSearchParams(
            Object.entries({
              ...params,
              lastKey: lastPage.lastKey,
            })
              // eslint-disable-next-line no-unused-vars
              .filter(([_k, v]) => v != null)
              .reduce((acc, [k, v]) => ({ ...acc, [k]: v }), {})
          ).toString();

          return `${url}?${paramString}`;
        }
      },
    }
  );
}
